"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.preventMacSleep = exports.timeout = exports.keepTrying = exports.sleep = exports.throttle = void 0;
const lodash_1 = __importDefault(require("lodash"));
/**
 * @returns throttled version of fn, with up to milliseconds per invocation
 */
function throttle(self, ms, fn) {
    return lodash_1.default.bind(lodash_1.default.throttle(fn, ms), self);
}
exports.throttle = throttle;
/**
 * sleep for ms
 */
function sleep(ms) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve) => setTimeout(resolve, ms));
    });
}
exports.sleep = sleep;
/**
 * keep invoking fn, catching errors, sleeping between invocations
 */
function keepTrying(fn, retries = 3, ms = 1000) {
    return __awaiter(this, void 0, void 0, function* () {
        let e;
        for (let i = 0; i < retries; i++) {
            try {
                return yield timeout(fn, ms);
            }
            catch (_e) {
                e = _e;
                yield sleep(ms);
            }
        }
        throw new Error("failed to invoke fn " + e);
    });
}
exports.keepTrying = keepTrying;
function timeout(fn, ms = 1000) {
    return __awaiter(this, void 0, void 0, function* () {
        let failed = false;
        const r = yield Promise.race([
            fn(),
            new Promise((resolve) => {
                setTimeout(() => {
                    failed = true;
                    resolve(null);
                }, ms);
            }),
        ]);
        if (!failed && !!r)
            return r;
        else
            throw new Error("timeout");
    });
}
exports.timeout = timeout;
/**
 * runs a shell command thats keeps macbooks from sleeping duing invocation of fn
 * automatically killing the spawned process on exit
 */
function preventMacSleep(fn) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!process.env.NODE)
            throw new Error("should only be called from node.js");
        const caffeinate = eval("require")("child_process").exec("caffeinate -dimsu");
        const kill = () => caffeinate.kill("SIGABRT");
        process.on("exit", kill);
        try {
            return yield fn();
        }
        finally {
            kill();
        }
    });
}
exports.preventMacSleep = preventMacSleep;
